<template>
  <div class="auth-page">
    <TheBreadcrumbs :links="breadCrumbsLinks"/>
    <div class="auth-page__content container">
      <div class="auth-page__inner container-inner">
        <div class="auth-page__toggle-wrap" v-if="windowSizeMixin.width < 768">
          <button type="button"
                  class="auth-page__toggle-btn base-btn"
                  @click.prevent="onToggleAuth"
          >
            <template v-if="showRegMob">
              <span>{{$tAuth('Login')}}</span>
              <BaseSvg name="ico-arrow-light"/>
            </template>
            <template v-else>
              <BaseSvg name="ico-arrow-light"/>
              <span>{{$tAuth('Registration')}}</span>
            </template>
          </button>
        </div>

        <div class="auth-page__main" v-if="windowSizeMixin.width > 767">
          <div class="auth-page__col">
            <AuthRegistr accent
                         :previousPage="previousPage"/>
          </div>
          <div class="auth-page__col">
            <AuthLogin socials
                       :previousPage="previousPage"/>
          </div>
        </div>

        <transition-group v-else
                          tag="div"
                          :name="showRegMob ? 'slide-right' : 'slide-left'"
                          class="auth-page__main">
          <div class="auth-page__col"
               v-show="showRegMob"
               :key="1"
          >
            <AuthRegistr accent/>
          </div>
          <div class="auth-page__col"
               v-show="!showRegMob"
               :key="2"
          >
            <AuthLogin :previousPage="previousPage"/>
          </div>
        </transition-group>
      </div>
    </div>
    <AuthSocials class="auth-page__socials" v-if="windowSizeMixin.width < 768"/>
  </div>
</template>

<script>
  import {setMetaRobots} from '../helpers/metaRobots'
  import globalMetaMixin from '../mixins/globalMetaMixin'
  import TheBreadcrumbs from "../components/Breadcrumbs";
  import formMixins from '../mixins/formMixins'
  import AuthLogin from '../components/AuthLogin'
  import AuthRegistr from '../components/AuthRegistr'
  import windowSizeMixin from '../mixins/windowSizeMixin'
  import AuthSocials from "../components/AuthSocials";

  export default {
    mixins: [formMixins, windowSizeMixin, globalMetaMixin],
    components: {
      AuthSocials,
      TheBreadcrumbs,
      AuthLogin,
      AuthRegistr,
    },
    data() {
      return {
        messageUser: null,
        showRegMob: true,
        previousPage: null
      }
    },
    computed: {
      breadCrumbsLinks() {
        return [{
          name: this.$tAuth('Authorization / registration')
        }]
      },
      getToken() {
        return this.$route.query.token
      }
    },
    methods: {
      onToggleAuth() {
        this.showRegMob = !this.showRegMob
      },

    },
    created() {
      if (this.getToken) {
        localStorage.setItem('token', this.getToken)
      }

      setMetaRobots('noindex, follow')
    },
    mounted() {
      if (this.getToken) {
        this.$store.dispatch('user/loginUserByToken', this.getToken)
        this.$store.dispatch('user/loadUser').then(() => {
          return this.$router.push({name: 'account-profile'})
        })
      }

      this.setMetaTitleMixin(this.$tMeta('auth-meta-title'))
      this.setMetaDescriptionMixin(this.$tMeta('auth-meta-description'))
      this.setOpenGraph({
        title: this.$tMeta('auth-meta-title'),
        description: this.$tMeta('auth-meta-description'),
      })
    },
    beforeRouteEnter(to, from, next) {
      if (from.name && to.name !== from.name) {
        return next(vm => {
          vm.previousPage = from
        })
      }

      next()
    }
  }
</script>

<style lang="less">


</style>
